<template>
  <SegmentHero v-bind="props">
    <slot />
  </SegmentHero>
</template>

<script setup>
import SegmentHero from "@/components/ui/SegmentHero.vue";

defineOptions({ name: "SolutionHero" });

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  primaryLabel: {
    type: String,
    default: "Solicite uma demonstração gratuita",
  },
  primaryHref: {
    type: String,
    default: "/contato",
  },
  secondaryLabel: {
    type: String,
    default: "",
  },
  secondaryHref: {
    type: String,
    default: "",
  },
  disclaimer: {
    type: String,
    default: "",
  },
  backgroundImage: {
    type: String,
    default: "",
  },
  backgroundClass: {
    type: String,
    default: "bg-gradient-to-b from-slate-900 via-slate-900 to-slate-800",
  },
  overlay: {
    type: Boolean,
    default: true,
  },
  overlayVariant: {
    type: String,
    default: "vertical",
  },
});
</script>
